// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__UX5uw","title":"style_title__9Vcou","description":"style_description__b-Fzi","btnWrapper":"style_btnWrapper__v7XIY"};